import { useEffect } from "react";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content || "");
}

export function useSeo({ title, description, canonical, jsonLd }) {
  useEffect(() => {
    if (!title) return;
    const prevTitle = document.title;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "article");
    if (canonical) {
      setMeta("property", "og:url", canonical);
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
      link.setAttribute("href", canonical);
    }
    let script = null;
    if (jsonLd) {
      script = document.createElement("script"); script.type = "application/ld+json"; script.text = JSON.stringify(jsonLd);
      script.setAttribute("data-seo-jsonld", "1"); document.head.appendChild(script);
    }
    return () => { document.title = prevTitle; script?.remove(); };
  }, [title, description, canonical, jsonLd]);
}
